import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserI } from 'src/app/models/user.interface';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss']

  
})
export class VerifyEmailComponent implements OnInit {

  public user:UserI = {} as UserI;

  constructor(protected router: Router,
    public authService: AuthService
  ) { }

  ngOnInit() {
    if(this.authService.userData != null) this.user = this.authService.userData;
      else this.user.email = "No email"
    
  }
  sendTo(url:string):void{
    console.log(url)
    this.router.navigate([url]);
  }
}